<template>
    <div class="defWid global-font-style">
        <div class="contact-info-div">
            <div class="top-padding"></div>
            <van-row>
                <van-col span="24">
                    <div class="field">
                        <div>
                            <span class="font-red">*</span>
                            <span>お名前</span>
                        </div>
                        <input v-model="name"
                               type="text"
                               class="normal-field-input"/>
                    </div>
                </van-col>
                <van-col span="24">
                    <div class="field">
                        <div>
                            <span class="font-red">*</span>
                            <span>メールアドレス</span>
                        </div>
                        <input v-model="email"
                               type="text"
                               class="normal-field-input"/>
                    </div>
                </van-col>
                <van-col span="24">
                    <div class="field">
                        <div>
                            <span class="font-red">*</span>
                            <span>電話番号</span>
                        </div>
                        <input v-model="phone"
                               type="text"
                               class="normal-field-input"/>
                    </div>
                </van-col>
                <van-col span="24">
                    <div class="field">
                        <div>
                            <span>貴社名・団体名</span>
                        </div>
                        <input v-model="company"
                               type="text"
                               class="normal-field-input"/>
                    </div>
                </van-col>
                <van-col span="24">
                    <div class="field">
                        <div>
                            <span>所属部署</span>
                        </div>
                        <input v-model="department"
                               type="text"
                               class="normal-field-input"/>
                    </div>
                </van-col>
                <van-col span="24">
                    <div class="field">
                        <div>
                            <span>役職</span>
                        </div>
                        <input v-model="job"
                               type="text"
                               class="normal-field-input"/>
                    </div>
                </van-col>
                <van-col span="24">
                    <div class="field">
                        <div>
                            <span>ご住所</span>
                        </div>
                        <input v-model="address"
                               type="text"
                               class="normal-field-input"/>
                    </div>
                </van-col>
                <van-col span="24">
                    <div class="field">
                        <div>
                            <span class="font-red">*</span>
                            <span>お問合わせ内容</span>
                        </div>
                        <textarea
                            v-model="text"
                            type="textarea"
                            class="text-field-input"
                            maxlength="3000"
                        />
                    </div>
                </van-col>
            </van-row>
        </div>
        <div class="contact-bot-div">
            <span class="contact-button"
                  @click="autoSendEmail">送信</span>
        </div>
        <div class="bot-padding"></div>
    </div>
</template>

<script>

    import Vue from 'vue'
    import {Row, Col, Image, Button, Icon, Field, Toast} from 'vant'

    Vue.use(Row)
    Vue.use(Col)
    Vue.use(Image)
    Vue.use(Button)
    Vue.use(Icon)
    Vue.use(Field)
    Vue.use(Toast)

    export default {
        name: 'Contact',
        data () {
            return {
                name: '',
                email: '',
                phone: '',
                company: '',
                department: '',
                job: '',
                address: '',
                text: '',
            }
        },
        methods: {
            autoSendEmail () {
                if(!this.checkInfo()) return
                // http://localhost:3000/sendmail
                fetch('https://www.booboolink.com:3000/sendmail', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        email: this.email,
                        name: this.name,
                        phone: this.phone,
                        company: this.company,
                        department: this.department,
                        job: this.job,
                        address: this.address,
                        text: this.text
                    })
                }).then(res => {
                    if(res.ok) {
                        Toast.success(`問い合わせメール送信しました`)
                        this.clearInfo()
                    } else {
                        Toast.fail(`fail with ${JSON.stringify(res.message)}`)
                    }
                }).catch(error => {
                    Toast.fail(`fail with ${JSON.stringify(error)}`)
                })
            },
            checkInfo () {
                let flag = true
                if (flag && this.name === '') {
                    flag = false
                }
                if (flag && this.email === '') {
                    flag = false
                }
                if (flag && this.phone === '') {
                    flag = false
                }
                if (flag && this.text === '') {
                    flag = false
                }
                if (flag && this.email.indexOf('@') === -1) {
                    flag = false
                }
                if (flag && this.email.indexOf('.') === -1) {
                    flag = false
                }
                if (flag) {
                    return true
                }
                Toast.fail('情報を確認して再試行してください')
                return false
            },
            clearInfo () {
                this.name = ''
                this.email = ''
                this.phone = ''
                this.company = ''
                this.department = ''
                this.job = ''
                this.address = ''
                this.text = ''
            }
        }

    }

</script>

<style>
    /* val = i6 */
    .global-font-style {
        font-size: 0.65rem;
    }

    .top-padding {
        padding-top: 1.8rem;
    }

    .bot-padding {
        padding-bottom: 1.8rem;
    }

    .normal-field-input {
        border: 0px;
        display: inline-block;
        width: 60%;
        height: 1rem;
    }

    .text-field-input {
        resize: none;
        border: 0px;
        display: inline-block;
        width: 60%;
        height: auto;
    }

    .contact-info-div {
        width: 80%;
        background-color: #fff5cc;
        margin: 0 auto;
    }
    /* iphone 5 */
    @media screen and (max-width: 320px) {
        .global-font-style {
            font-size: 0.45rem;
        }
        .contact-info-div {
            width: 90%;
        }
    }

    /* val = iX */
    @media screen and (min-width: 375px) and (-webkit-device-pixel-ratio: 3) {
    }

    /* val = i6p */
    @media screen and (min-width: 414px) {
        .contact-info-div {
            width: 75%;
        }

        .top-padding {
            padding-top: 2rem;
        }

        .bot-padding {
            padding-bottom: 2rem;
        }

    }

    /* val = ipad */
    @media screen and (min-width: 768px) {
        .global-font-style {
            font-size: 0.8rem;
        }
        .normal-field-input {
            height: 1.5rem;
        }
        .text-field-input {
            height: 7rem;
        }
        .contact-info-div {
            width: 70%;
        }

        .top-padding {
            padding-top: 2.4rem;
        }

        .bot-padding {
            padding-bottom: 2.4rem;
        }

    }

    /* val = ipadp */
    @media screen and (min-width: 1024px) {
        .contact-info-div {
            width: 65%;
        }
        .top-padding {
            padding-top: 2.7rem;
        }

        .bot-padding {
            padding-bottom: 2.7rem;
        }


    }

    /* val = pc */
    @media screen and (min-width: 1100px) {

        .normal-field-input {
            width: 75%;
            height: 1.5rem;
        }

        .text-field-input {
            width: 75%;
            height: 7rem;
        }

        .global-font-style {
            font-size: 1rem;
        }
        .normal-field-input {
            height: 1.7rem;
        }
        .text-field-input {
            height: 8rem;
        }
        .contact-info-div {
            width: 60%;
        }

        .top-padding {
            padding-top: 3rem;
        }

        .bot-padding {
            padding-bottom: 3rem;
        }

    }
    .hidden {
        visibility: hidden;
    }

    .font-red {
        color: red;
    }

    .info-margin-top {
        height: 2rem;
    }

    .field {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 1rem auto;
    }

    .contact-button {
        font-size: 1rem;
        font-weight: 700;
        white-space: nowrap;
        vertical-align: middle;
        background: #ffe401;
        -webkit-appearance: none;
        text-align: center;
        box-sizing: border-box;
        cursor: pointer;
        padding: 0.5rem 2.8rem;
        border-radius: 0.3rem;
    }

</style>
